<template>
  <div>
    <el-row class="container">
      <el-row>
        <h2>Daily PPM Details</h2>
      </el-row>
      <!-- System Selection -->
      <el-row>
        <el-col :span="4" align="left">
          <div class="tag">
            <strong>Select System:</strong>
          </div>
        </el-col>
        <el-col :span="20" align="left">
          <el-select
            v-model="system"
            placeholder="Select System"
            size="mini"
            :style="{ width: '250px' }"
          >
            <el-option
              label="General System"
              value="General System"
            ></el-option>
          </el-select>
        </el-col>
      </el-row>
      <!-- Hall Selection -->
      <el-row>
        <el-col :span="4" align="left">
          <div class="tag">
            <strong>Select Hall:</strong>
          </div>
        </el-col>
        <el-col :span="20" align="left">
          <el-select
            v-model="selectedHall"
            :style="{ width: '250px' }"
            placeholder="Select Hall"
            clearable
            size="mini"
          >
            <el-option
              v-for="item in halls"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-col>
      </el-row>
      <!-- Date Selection -->
      <el-row>
        <el-col :span="4" align="left">
          <div class="tag">
            <strong>Select Date:</strong>
          </div>
        </el-col>
        <el-col :span="20" align="left">
          <el-date-picker
            v-model="date"
            type="date"
            :style="{ width: '250px' }"
            placeholder="Select Date"
            format="dd/MM/yyyy"
            value-format="yyyy-MM-dd"
            size="mini"
          ></el-date-picker>
        </el-col>
      </el-row>
      <!-- Foreman Selection -->
      <el-row>
        <el-col :span="4" align="left">
          <div class="tag">
            <strong>Select Foreman:</strong>
          </div>
        </el-col>
        <el-col :span="20" align="left">
          <el-select
            v-model="foreman"
            filterable
            :style="{ width: '250px' }"
            remote
            size="mini"
            @change="clearSearch"
            clearable
            placeholder="Select Foreman"
            :remote-method="foremanMethod"
            :loading="loading"
          >
            <el-option
              v-for="item in availableForemen"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-col>
      </el-row>
      <!-- AIA Sen. Tech Selection -->
      <el-row>
        <el-col :span="4" align="left">
          <div class="tag">
            <strong>Select AIA Sen. Tech:</strong>
          </div>
        </el-col>
        <el-col :span="20" align="left">
          <el-select
            v-model="senTech"
            filterable
            :style="{ width: '250px' }"
            remote
            size="mini"
            @change="clearSearch"
            clearable
            placeholder="Select AIA Sen. Tech"
            :remote-method="senTechMethod"
            :loading="loading"
          >
            <el-option
              v-for="item in availableSenTechs"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-col>
      </el-row>
    </el-row>

    <br />

    <el-row class="container">
      <el-row>
        <h2>Personnel</h2>
      </el-row>
      <el-row>
        <el-col :span="6">
          <div class="tag">
            <strong>Tech Name</strong>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="tag">
            <strong>Date</strong>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="tag">
            <strong>Time Started</strong>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="tag">
            <strong>Time Ended</strong>
          </div>
        </el-col>
      </el-row>
      <el-row v-for="(p, index) in techs" :key="index" v-if="techs[index].id">
        <el-col :span="6">
          <el-select
            v-model="techs[index].id"
            filterable
            :style="{ width: '220px' }"
            remote
            size="mini"
            @focus="foremanMethod"
            @change="techUpdate(techs[index].id, index)"
            clearable
            placeholder="Add Technician"
            :remote-method="foremanMethod"
            :loading="loading"
          >
            <el-option
              v-for="item in availableForemen"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <el-date-picker
            v-model="techs[index].date"
            type="date"
            placeholder="Date"
            size="mini"
            format="dd/MM/yyyy"
            value-format="yyyy-MM-dd"
            :style="{ width: '150px' }"
          ></el-date-picker>
        </el-col>
        <el-col :span="6">
          <el-input
            placeholder="00:00"
            v-on:input="startTimeChange(index)"
            v-model="techs[index].start"
            size="mini"
            maxlength="5"
            :style="{ width: '150px' }"
          ></el-input>
        </el-col>
        <el-col :span="6">
          <el-input
            placeholder="00:00"
            v-on:input="endTimeChange(index)"
            v-model="techs[index].end"
            size="mini"
            maxlength="5"
            :style="{ width: '150px' }"
          ></el-input>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <el-select
            v-model="selectedTech"
            filterable
            @change="pushPersonnel"
            :style="{ width: '150px' }"
            remote
            size="mini"
            clearable
            placeholder="Add Technician"
            :remote-method="foremanMethod"
            :loading="loading"
          >
            <el-option
              v-for="item in availableForemen"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-col>
      </el-row>
    </el-row>

    <br />

    <el-row class="container">
      <el-row>
        <h2>Inspection Remarks</h2>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6" align="left">
          <div class="tag">
            <strong>Remarks</strong>
          </div>
        </el-col>
        <el-col :span="4" align="left">
          <div class="tag">
            <strong>Proposed Actions</strong>
          </div>
        </el-col>
        <el-col :span="4" align="left">
          <div class="tag">
            <strong>Work Order ID</strong>
          </div>
        </el-col>
        <el-col :span="10" align="left">
          <div class="tag">
            <strong>Description</strong>
          </div>
        </el-col>
      </el-row>
      <el-row v-for="(remark, index) in remarksList" :key="index" :gutter="10">
        <el-col :span="6" align="left">
          <el-input
            type="textarea"
            v-model="remark.text"
            placeholder="Enter your remarks here"
            :rows="1"
            :style="{ width: 'calc(100% - 10px)', marginRight: '5px' }"
            @change="addRemarkLine(index)"
          ></el-input>
        </el-col>
        <el-col :span="4" align="left">
          <el-select
            v-model="remark.action"
            placeholder="Select Action"
            size="mini"
            :style="{ width: '100%' }"
          >
            <el-option
              v-for="action in proposed_action"
              :key="action"
              :label="action"
              :value="action"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="4" align="left">
          <el-select
            v-model="remark.workOrderId"
            filterable
            :style="{ width: '100%' }"
            remote
            size="mini"
            @change="WOUpdate(remark.workOrderId, index)"
            clearable
            placeholder="Add Work Order"
            :remote-method="workOrderMethod"
            :loading="loading"
          >
            <el-option
              v-for="item in availableWorkOrders"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="10" align="left">
          <p
            v-if="remark.workOrderId"
            style="text-align: left; margin-top: 5px; padding: 5px; border: 1px solid rgb(0, 0, 0); width: 150%;"
          >
            {{ getWorkOrderDescription(remark.workOrderId) }}
          </p>
        </el-col>
      </el-row>
    </el-row>

    <br />

    <el-row class="container">
      <el-row>
        <h2>Status</h2>
      </el-row>
      <el-row>
        <el-col :span="4" align="left">
          <div class="tag">
            <strong>Select Status:</strong>
          </div>
        </el-col>
        <el-col :span="20" align="left">
          <el-select
            v-model="status"
            placeholder="Status"
            size="mini"
            :style="{ width: '200px' }"
            clearable
          >
            <el-option
              v-for="item in statuses"
              :key="item.id"
              :label="item.literal"
              :value="item.literal"
            ></el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row v-if="status !== 'Pending'">
        <el-col :span="4" align="left">
          <div class="tag">
            <strong>Completion Date</strong>
          </div>
        </el-col>
        <el-col :span="12">
          <el-date-picker
            v-model="completionDate"
            type="date"
            placeholder="Completion Date"
            format="dd/MM/yyyy"
            value-format="yyyy-MM-dd"
            size="mini"
            :style="{ width: '200px' }"
          ></el-date-picker>
        </el-col>
      </el-row>
    </el-row>

    <el-row style="margin-top: 20px;">
      <el-button type="success" @click="submitPPMDaily">Submit</el-button>
    </el-row>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import { personnel } from "../../api/personnel/personnel";
import { aiaPersonnel } from "../../api/personnel/aiaPersonnel";
import PersonnelSelector from "../Selectors/PersonnelSelector.vue";
import StatusSelector from "../Selectors/StatusSelector.vue";
import { workorder } from "../../api/workorder/workorder";
import { postgrest } from "../../api/postgrest";

@Component({
  name: "AddPPMnew",
  props: {
    isDialog: {
      default: false,
    },
  },
  components: {
    StatusSelector,
    PersonnelSelector,
  },
})
export default class AddPPMnew extends Vue {
  public system: string = "General System";
  public proposed_action: string[] = ["TBM", "TBC", "TBR", "TBF"];
  public halls: string[] = ["North", "South", "S+N"];
  public groups: any[] = [];
  public selectedHall: string = "";
  public date: any = "";
  public senTechList: any[] = [];
  public senTechs: any[] = [];
  public availableSenTechs: any[] = [];
  public senTech: any = "";
  public loading: boolean = false;
  public availableForemen: any[] = [];
  public personnelList: any[] = [];
  public foremen: any[] = [];
  public workers: any[] = [];
  public foreman: any = "";
  public techs: any[] = [{ start: '06:00' }];
  public standbyTechs: any[] = [];
  public personnel: any[] = [];
  public status: any = "";
  public completionDate: any = null;
  public selectedAction: any = "";
  public remarksList: any[] = [
    { text: "", action: "", workOrderId: "", description: "" },
  ];
  public workOrders: any[] = [];
  public availableWorkOrders: any[] = [];
  public selectedWorkOrder: any = "";
  public workOrderList: any[] = [];
  public selectedComponent = "";
  public workOrderDescription: string = "";
  public selectedTech: any = "";
  public components: any[] = [];
  public statuses: any[] = [];
  public ppm_details: any;
  public periodicity: string = "Daily";

  public async created() {
    await this.getSenTechList();
    await this.getPersonnelList();
    await this.getWorkOrderList();
    await this.getStatuses();

  }

  public senTechMethod(query: string) {
    if (query != "" && query != undefined) {
      this.loading = true;
      this.availableSenTechs = this.senTechs.filter((item) => {
        return (
          item.label.toLowerCase().indexOf(query.toLowerCase()) > -1 ||
          item.team == query
        );
      });
      this.loading = false;
    } else {
      this.availableSenTechs = [];
    }
  }

  public foremanMethod(query: string) {
    if (query != "" && query != undefined) {
      this.loading = true;
      this.availableForemen = this.foremen
        .filter((item) => {
          return (
            (item.label.toLowerCase().indexOf(query.toLowerCase()) > -1 ||
              item.team == query) &&
            this.foreman !== item.value &&
            !this.techs.some((r) => r.value === item.value) &&
            !this.standbyTechs.some((r) => r.value === item.value)
          );
        })
        .concat(
          this.workers.filter((item) => {
            return (
              (item.label.toLowerCase().indexOf(query.toLowerCase()) > -1 ||
                item.team == query) &&
              this.foreman !== item.value &&
              !this.techs.some((r) => r.value === item.value) &&
              !this.standbyTechs.some((r) => r.value === item.value)
            );
          })
        );
      this.loading = false;
    } else {
      this.availableForemen = [];
    }
  }

  public async submitPPMDaily() {

  let filteredRemarks = this.remarksList.filter(remark => 
    remark.text !== "" || remark.action !== "" || remark.description !== "" || remark.workOrderId !== ""
  );

  this.ppm_details = {
    system: 8,
    // subsystem: null, 
    hall: this.selectedHall,
    date: this.date,
    foreman: this.foreman,
    sen_tech: this.senTech,
    techs: this.techs,
    remarks: filteredRemarks,
    status: this.status,
    recycled: false, 
    periodicity: this.periodicity,
  };

  if (this.status !== "Pending") {
      this.ppm_details.completion_date = this.completionDate || null;
    }

  try {
    const token = this.$store.getters.getToken;
    const response = await postgrest.post(
      "ppm_details",
      token,
      this.ppm_details
    );
    console.log(response);
    this.$message.success({
      message: "PPM Daily Submitted Successfully",
      showClose: true,
    });

    if (this.$props.isDialog === false) {
    this.$store.dispatch("updateCurrentObject", {});
    this.$store.dispatch("updateCurrentComponent", "PPMList");
    this.$router.replace({
      name: "load",
    });
  };
  } catch (error) {
    console.log("Error posting data to PostgREST:", error); 
      this.$message.error("Failed to submit PPM");
  }
}

  public async getStatuses() {
    try {
      this.statuses = await postgrest.get(
        "status",
        this.$store.getters.getToken
      );
    } catch (error) {
      console.error("Error fetching statuses:", error);
    }
  }

  public async getPersonnelList() {
    try {
      const response = await personnel.getAllPersonnel(
        this.$store.getters.getToken,
        this.$store.getters.getHost
      );
      const resp = await response.json();
      this.personnelList = JSON.parse(JSON.stringify(resp));
      this.personnelList.forEach((p) => {
        if (this.$store.getters.getUserLevel < 1 || p.active) {
          if (p.wo_specialty == 1) {
            this.foremen.push({
              label: `${p.firstname} ${p.lastname}${
                !p.active ? " (INACTIVE)" : ""
              }`,
              value: p.id,
              team: p.team,
            });
          } else {
            this.workers.push({
              label: `${p.firstname} ${p.lastname}${
                !p.active ? " (INACTIVE)" : ""
              }`,
              value: p.id,
              team: p.team,
            });
          }
        }
      });
    } catch (error) {
      console.error("Error fetching personnel list:", error);
    }
  }

  public async getSenTechList() {
    try {
      const response = await aiaPersonnel.getAllPersonnel(
        this.$store.getters.getToken,
        this.$store.getters.getHost
      );
      const resp = await response.json();
      this.senTechList = JSON.parse(JSON.stringify(resp));
      this.senTechList.forEach((p) => {
        this.senTechs.push({
          label: `${p.firstname} ${p.lastname}`,
          value: p.id,
          team: p.team,
        });
      });
    } catch (error) {
      console.error("Error fetching SenTech list:", error);
    }
  }

  public async getWorkOrderList() {
    try {
      const response = await workorder.getSomeWorkOrders(
        this.$store.getters.getToken,
        {},
        this.$store.getters.getHost
      );
      const resp = await response.json();
      this.workOrderList = resp.map((order: any) => ({
        value: order.aia_id.toString(),
        label: order.aia_id.toString(),
        key: order.aia_id,
        description: order.name,
      }));
    } catch (error) {
      console.error("Error fetching work orders:", error);
    }
  }

  public pushWorkOrder() {
    if (this.selectedWorkOrder) {
      const selected = this.workOrderList.find(
        (r) => r.value == this.selectedWorkOrder
      );
      if (selected) {
        this.workOrders.push({
          id: selected.value,
          description: selected.description,
        });
        this.selectedWorkOrder = "";
      }
    }
  }

  public workOrderMethod(query: string) {
    if (query) {
      this.availableWorkOrders = this.workOrderList.filter((item) => {
        return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
      });
    } else {
      this.availableWorkOrders = [];
    }
  }

  public clearSearch() {
    this.availableForemen = [];
  }

  public techUpdate(id: any, index: number) {
    if (id === "") {
      this.techs.splice(index, 1);
    }
  }

  public endTimeChange(index: number) {
    if (this.techs[index].end.length === 2) {
      this.techs[index].end += ":";
    }
  }

  public startTimeChange(index: number) {
    if (this.techs[index].start.length === 2) {
      this.techs[index].start += ":";
    }
  }

  public WOUpdate(id: any, index: number) {
    if (id === "") {
      this.remarksList[index].description = "";
    } else {
      const selected = this.workOrderList.find((r) => r.value == id);
      if (selected) {
        this.remarksList[index].description = selected.description;
      }
    }
  }

  public pushPersonnel() {
    const selectedPersonnel = this.personnelList.find(
      (r) => r.id == this.selectedTech
    );
    if (selectedPersonnel) {
      this.techs.push({
        id: this.selectedTech,
        label: `${selectedPersonnel.firstname} ${selectedPersonnel.lastname}`,
        start: "",
        end: "",
      });
      this.selectedTech = "";
    }
  }

  public addRemarkLine(index: number) {
    if (this.remarksList[index].text !== "") {
      this.remarksList.push({
        text: "",
        action: "",
        workOrderId: "",
        description: "",
      });
    }
  }

  public getWorkOrderDescription(id: string) {
    const selected = this.workOrderList.find((r) => r.value == id);
    return selected ? selected.description : "";
  }
}
</script>

<style scoped>
.container {
  padding: 20px;
  background-color: #e4e2e2;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
}

h2 {
  color: #333;
  font-weight: 600;
  margin-bottom: 20px;
  border-bottom: 2px solid #409eff;
  padding-bottom: 10px;
}

.tag {
  font-size: 12px;
  color: #666;
  margin-bottom: 5px;
}

.el-col {
  display: flex;
  align-items: center;
}

.el-col-14 {
  width: 80%;
}

.el-col .el-select,
.el-col .el-date-picker,
.el-col .el-input {
  width: 100%;
}

.el-select .el-input__inner,
.el-date-picker .el-input__inner,
.el-input .el-textarea__inner {
  border-radius: 4px;
  border-color: #409eff;
}

.remarks-tag,
.actions-tag,
.workorder-tag {
  width: 100%;
}

.workorder-tag .tagText {
  margin-bottom: 5px;
}
</style>
